<div class="section pb-24" [formGroup]="parentForm">
  <div class="pb-16" fxLayout="row" fxLayoutAlign="start center">
    <div class="h2 secondary-text">Publishing</div>
  </div>
  <app-form-group [form]="parentForm" [controls]="controls"></app-form-group>
</div>
